module.exports = __webpack_public_path__ + "img/not_bind.87a5da86.svg";